var map = {
	"./1eshospital.png": 560,
	"./2research.jpg": 372,
	"./Bayan2.jpg": 561,
	"./Bayan_logo.png": 562,
	"./Bayan_logo1.png": 373,
	"./DR_bg.bmp": 563,
	"./DR_bg.svg": 564,
	"./DR_bg_clear.bmp": 565,
	"./Huda2.jpg": 566,
	"./Huda_logo.png": 567,
	"./Huda_logo1.png": 374,
	"./Kareem_logo1.jpg": 375,
	"./Kayan-Healthcare-Logo.svg": 568,
	"./NGI.png": 569,
	"./Prime.jpg": 570,
	"./Sama2.jpg": 571,
	"./Sama_logo.png": 572,
	"./Sama_logo1.png": 376,
	"./Sanad2.jpg": 573,
	"./Sanad_logo.png": 574,
	"./Sanad_logo1.png": 377,
	"./Sayan2.jpg": 575,
	"./Sayan_logo.png": 576,
	"./Sayan_logo1.png": 290,
	"./Soma.jpg": 378,
	"./Somod_logo.png": 577,
	"./Somod_logo1.png": 578,
	"./Tunbay.png": 579,
	"./aafiya.png": 580,
	"./aafiya2.png": 581,
	"./box.bmp": 582,
	"./box2-0.bmp": 583,
	"./dr1.svg": 584,
	"./eshospital.png": 585,
	"./fakeeh.jpg": 586,
	"./first.jpg": 587,
	"./health-insurance.jpg": 588,
	"./hospital.jpg": 589,
	"./img2.jpg": 379,
	"./kareem.jpg": 380,
	"./kayan-ceo.jpg": 381,
	"./kayan.PNG": 590,
	"./kayanLogo.jpg": 591,
	"./kayan_background.jpg": 592,
	"./kayan_no_bg.png": 593,
	"./linkedin.webp": 594,
	"./location.svg": 595,
	"./london.jpg": 596,
	"./market.jpg": 382,
	"./mohammed.jpg": 597,
	"./right.PNG": 598,
	"./scroll.webp": 383,
	"./sec_bg.png": 599,
	"./second.jpg": 600,
	"./service1.webp": 384,
	"./service2.webp": 385,
	"./service3.webp": 386,
	"./services.jpg": 387,
	"./teamCover.webp": 388,
	"./thumbay.jpg": 601,
	"./zulekha-hospital-logo.png": 602,
	"./zulekha.png": 603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 559;